var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPackageFill = function SvgPackageFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.725v-9.15L3 7.95v8.025A1.95 1.95 0 0 0 4 17.7zm2 0 7-4.025q.475-.275.738-.725.262-.45.262-1V7.95l-8 4.625zm3.975-13.75 2.95-1.725L13 2.275A1.97 1.97 0 0 0 12 2q-.525 0-1 .275L9.025 3.4zM12 10.85l2.975-1.7-7.925-4.6-3 1.725z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPackageFill);
export { ForwardRef as ReactComponent };